import React from 'react'
import PropTypes from 'prop-types'
import settings from '@nobia/zeus-components/lib/settings'
import { Helmet } from '@nobia/zeus-components/lib/router'
import App from './App'

const sentryScript = `
  if (window.Raven) {
    Raven.config('${settings.sentry}', {
      environment: '${settings.profile}',
      tags: { brand: '${settings.brand}' }
    }).install();
  }
`
const Application = props => (
  <>
    <App embedBlockId={props.embedBlockId} />
    <Helmet>
      <link
        rel="stylesheet"
        type="text/css"
        href="https://rawgit.com/vn38minhtran/react-photoswipe/next/dist/photoswipe.css"
      />
      <script
        src="https://cdn.ravenjs.com/3.27.0/raven.min.js"
        crossOrigin="anonymous"
      />
      {settings.sentry && <script innerHTML={sentryScript} />}
    </Helmet>
  </>
)

Application.defaultProps = {
  embedBlockId: null,
}

Application.propTypes = {
  embedBlockId: PropTypes.string,
}

export default Application
